<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
  <div>
    <section id="hero">
        <v-img
          aspect-ratio="16/16"
          :min-height="minHeight"
          :src="require('../../../static/img/home-hero.jpg')"
          class="white--text"
          gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
        >
          <v-container class="fill-height px-4 py-12">
            <v-responsive
              class="d-flex align-center"
              height="100%"
              max-width="700"
              width="100%" PROMOTE
            >
              <base-heading title="易途自2008年创办之日起紧随市场需求" />

              <base-body>
                凭借强大的技术实力和多年积累的技术人才，于2015年成立外包服务平台，先后与山东浪潮集团、山东中创集团、华为集团、中国联通、中国电信、交通银行、安永、德勤、上汽集团、中石油、中海油、国家电网以及多地公安、交警系统等众多企业直接或间接达成深度合作，覆盖包含能源行业、金融行业、物流行业、电子商务、互联网、制造业、通信业、政府部门等领域。本着“打造中国最有情怀的外包服务平台”的核心价值观，以及“让基层IT者劳有所得”的信念，外包服务人才规模已由最开始不到10人发展500余人，并每年保持稳步增长。
              </base-body>

              <div
                :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
                class="d-flex flex-wrap"
              >
                <base-btn @click="dropUsALine">
                  联系我们
                </base-btn>

                <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

                <base-btn
                  :ripple="false"
                  class="pa-1"
                  height="auto"
                  text
                  @click="toServiceCase"
                >
                  查看案例
                </base-btn>
              </div>
            </v-responsive>
          </v-container>
        </v-img>
    </section>
    <section>
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions">
        </video-player>
    </section>

    <div class="py-12"></div>
    <section>
      <base-section-heading
        color="grey lighten-2"
        icon="mdi-vuetify"
        title="
      客户案例"
      />

      <v-container>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            md="4"
          >
            <base-info-card v-bind="card" />
          </v-col>
        </v-row>
      </v-container>
    </section>
    <div class="py-12"></div>
    <section>
      <base-section-heading title="全栈式 · 全战士">
        一条正途 一条征途<br/>
        年少的梦 少年来成<br/>
        我们教 教那些不会的不懂的不知所云的<br/>
        我们炼 炼那些顽固的执拗的狂妄自大的<br/>
        我们给 给那些有种的背水的一意孤行的<br/>
        我们服 服那些圆梦的翻身的人生转折的<br/><br/>
        易途在职的外包&研发程序人员实时名录<br/>
        部分涉密项目/人员已做加密处理
      </base-section-heading>

      <v-container>
        <v-row>
          <v-col
            v-for="(feature, i) in features"
            :key="i"
            cols="12"
            md="6"
          >
            <v-card
              class="mx-auto"
              max-width="434"
              tile
            >
              <v-img
                height="100%"

                src="../../../static/waibao/wbbg2.jpg"
              >
                <v-row
                  align="end"
                  class="fill-height"
                >
                  <v-col
                    align-self="start"
                    class="pa-0"
                    cols="12"
                  >
                    <v-row>
                      <v-col md="4">
                        <v-avatar
                          class="profile"
                          color="grey"
                          size="154"
                          tile
                        >
                          <v-img :src="feature.img">
                            <v-img src="../../../static/waibao/ds.png">

                            </v-img>
                          </v-img>
                        </v-avatar>
                      </v-col>
                      <v-col class="body-2 mr-3" v-html="feature.desc">
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-list-item
                      color="rgba(0, 0, 0, .4)"
                      dark
                    >
                      <v-list-item-content>
                        <v-list-item-title class="title">{{ feature.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ feature.motto }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-img>
            </v-card>
<!--            <base-avatar-card-->
<!--              v-bind="feature"-->
<!--              align="left"-->
<!--              horizontal-->
<!--            >-->
<!--              Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!-->
<!--            </base-avatar-card>-->
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</v-responsive>
</template>

<script>

  import BaseHeading from '../../components/base/Heading'
  import BaseBody from '../../components/base/Body'
  import BaseBtn from '../../components/base/Btn'
  import BaseSectionHeading from '../../components/base/SectionHeading'
  import BaseInfoCard from '../../components/base/InfoCard'
  import BaseAvatarCard from '../../components/base/AvatarCard'
  import { videoPlayer } from 'vue-video-player';


  export default{
    components: {
      BaseHeading,
      BaseBody,
      BaseBtn,
      BaseSectionHeading,
      BaseInfoCard,
      BaseAvatarCard,
      videoPlayer},
    data(){
			return{
        playerOptions: {
          //播放速度
          playbackRates: [0.5, 1.0, 1.5, 2.0],
          //如果true,浏览器准备好时开始回放。
          autoplay: false,
          // 默认情况下将会消除任何音频。
          muted: false,
          // 导致视频一结束就重新开始。
          loop: false,
          // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          preload: 'auto',
          language: 'zh-CN',
          // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          aspectRatio: '16:9',
          // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          fluid: true,
          sources: [{
            //类型
            type: "video/mp4",
            //url地址
            src: '../../../static/video/waibao.mp4'
          }],
          //你的封面地址
          poster: '',
          //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            //全屏按钮
            fullscreenToggle: true
          }
        },
        features: [

          {
            color: 'primary',
            title: 'Image Parallax',
            icon: 'mdi-image-size-select-actual',
            img:'../../../static/waibao/wl.jpg',
            name:'王磊',
            motto:'机会永远都是给有准备的人准备的。',
            desc:'七年开发经验，三年管理经验，曾服务北京联通智慧城市项目、青建集团综合管理平台、上海劲牛智慧农业平台、上海兼蜜每刻兼职项目、上海大润发会员分析平台、杭州华数推荐系统、北京天润员工管理平台、伊利大数据平台等多个项目，在建筑、电商、传媒、智慧城市、大数据应用等多个领域经验丰富。',
          },
          {
            color: 'primary',
            title: 'Retina Ready',
            icon: 'mdi-cellphone',
            img:'../../../static/waibao/zhr.png',
            name:'支唤然',
            motto:'付出不一定会立马有收获，但不付出肯定没收获。',
            desc:'六年开发经验，两年架构经验，曾服务山东浪潮农基项目、陕西秦电项目、中国联通PM项目、中国远洋项目、杭州聚贸架构项目、SGS<br/>-SODA项目等多个现场，在金融、通信、电商、智能政务等多个领域积累了丰富的实战经验。',
          },
          {
            color: 'primary',
            title: 'Pixel Perfect Design',
            icon: 'mdi-fountain-pen-tip',
            img:'../../../static/waibao/lj.png',
            name:'李杰',
            motto:'没有难学的技术，只差正确的方法。',
            desc:'六年开发经验，两年管理经验，曾参与华数统一广告平台、联通PMS3.0集成系统、电网集<br/>群需求响应与电网态势联动控制系统、青岛海尔日日顺快线财务管理平台、青岛海尔顺逛HBDM系统、海信财务共享平台等多个项目的研发和管理，在物联网、通信、电商、传媒等多个领域颇有建树。',
          },
          {
            color: 'primary',
            title: 'Easily Customizable',
            icon: 'mdi-pencil-box-outline',
            img:'../../../static/waibao/xn.png',
            name:'许宁',
            motto:'永不言弃。',
            desc:'八年开发经验，四年管理经验，曾承担海信行业监管平台的多个模块的设计与开发,多模块通讯数据的接入设计与开发，视频模块接入的设计与开发，海尔巨商汇交易平台伞下会员与服务商会员相关功能的设计与开发，担任巨商汇交易平台的运营主管，处理客户上报的线上问题的分析、指派与解决。',
          },
          {
            color: 'primary',
            title: 'Easily Customizable',
            icon: 'mdi-pencil-box-outline',
            img:'../../../static/waibao/shy.png',
            name:'孙恒源',
            motto:'不要再追逐光明了，努力让自己发光吧。',
            desc:'五年开发经验，曾担任海尔产销平台、海尔网格显示平台、海尔大宗商品平台、海尔日日顺快线项目、海尔净水项目组等多个项目的主研发工作，技术精湛，责任心强，多次受到客户好评。',
          },
          {
            color: 'primary',
            title: 'Easily Customizable',
            icon: 'mdi-pencil-box-outline',
            img:'../../../static/waibao/fh.png',
            name:'付昊',
            motto:'Just do IT',
            desc:'四年开发经验，曾担任宁德新能源andon管理系统、北京社会养老福利津贴系统、胜利油田热电联供客服平台、胜利油田生产指挥系统、海淀智慧执法监督项目等多个项目的主研发工作，技术精湛，沟通协作能力强，多次受到客户好评。',
          },
        ],
        cards: [
          {
            title: '海信集团',
            subtitle: '团队驻场服务',
            text: '中级开发人员38人；高级开发人员6人；资深开发人员1人',
            callout: '01',
          },
          {
            title: '海尔集团',
            subtitle: '团队驻场服务',
            text: '中级开发人员20人；高级开发人员4人',
            callout: '02',
          },
          {
            title: '中国联通',
            subtitle: '团队驻场服务',
            text: '中级开发人员42人；高级开发人员8人；资深开发人员1人',
            callout: '03',
          },
        ],
      }
		},
		created(){

		},
		methods:{
      dropUsALine(){
        this.$router.push('/contact');
        let x = this.$store.state.tabItem.find((x) => x && x.id == this.$store.state.menuItems[5].id);
        if(x) return;
        this.$store.commit("addTabItem",this.$store.state.menuItems[5]);
      },
      toServiceCase(){
        this.$router.push('/serviceCase');
        let x = this.$store.state.tabItem.find((x) => x && x.id == this.$store.state.menuItems[1].items[1].id);
        if(x) return;
        this.$store.commit("addTabItem",this.$store.state.menuItems[1].items[1]);
      }
		},
    provide: {
      theme: { isDark: true },
    },
    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
      player() {
        return this.$refs.videoPlayer.player
      }
    },
	}
</script>

<style>
  .demo{
    display: inline-block;
    width: 800px;
    /*height: 1080px;*/
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo:hover{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/page/waibao/businessProfile.vue